<template>
  <div class="text-center">
    <b-row class="d-flex justify-content-center">
      <b-col
        class="mb-5"
        :cols="10"
        :sm="8"
        :md="6"
      >
        <b-img
          :src="require(`@/assets/images/logo-black-${$i18n.locale}.svg`)"
          fluid
        />
      </b-col>
      <b-col :cols="12">
        <BaseTextH2>{{ $t('that-page-does-not-exist') }}</BaseTextH2>
        <p>{{ $t('sorry-tha-page-you-were-looking-for-could-not-be-found') }}</p>
      </b-col>
      <b-col
        :cols="12"
        class="py-4"
      >
        <a href="/">
          <BaseButton
            is-rounded
            size="lg"
            font-size="big"
          >
            <span class="px-2">{{ $t('return-to-homepage') }}</span>
          </BaseButton>
        </a>
      </b-col>
    </b-row>
    <BaseLoading v-if="isLeaguesLoading" />
    <b-row v-if="!isLeaguesLoading && leagues.length">
      <b-col :cols="12">
        <p class="my-4">
          {{ $t('or-browse-your-favourite-leagues') }}
        </p>
      </b-col>
      <b-col
        v-for="({ id, name, slug, image_url }) in leagues"
        :key="`league-${id}`"
        class="d-flex justify-content-center align-items-center"
      >
        <a
          :href="`/${slug}`"
          :class="$style.leagueImageWrapper"
        >
          <b-img-lazy
            :src="image_url"
            :alt="name[$i18n.locale]"
            :blank-src="require('@/assets/images/spinner_white.svg')"
            fluid-grow
          />
        </a>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import BaseButton from '@/components/Atoms/BaseButton'
import BaseTextH2 from '@/components/Atoms/Typography/BaseTextH2'
import BaseLoading from '@/components/Atoms/BaseLoading'

export default {
  components: {
    BaseLoading,
    BaseTextH2,
    BaseButton,
  },
  props: {},
  metaInfo() {
    return {
      title: this.$t('page-titles.page-not-found'),
      meta: [
        { name: 'description', content: this.$t('page-descriptions.page-not-found') },
      ],
    }
  },
  computed: {
    ...mapState({
      isLeaguesLoading: state => state['leagues/index'].isLeaguesLoading,
    }),
    leagues() {
      return this.$store.getters['leagues/index/getLeaguesForSport']({ sportId: 1 })
    },
  },
  mounted() {
    this.fetchLeagues({ sportId: 1 })
  },
  methods: {
    ...mapActions({
      fetchLeagues: 'leagues/index/fetchLeagues',
    }),
  },
}
</script>

<style module lang="scss">
  .leagueImageWrapper {
    max-width: 125px;
  }
</style>
